import {Camera, deserializeTemplateGraph, getOwnedNodes, isTemplateNode} from "@cm/template-nodes"
import type {IModifyTemplateGraph, TemplateGraph} from "@cm/template-nodes"
import type {SerializedGraphNode} from "@cm/graph-v3"

export const DEFAULT_CAMERA_TEMPLATE_ID = "9f5c9e73-4f52-4791-b90f-9b71f83392ec"

export function extractDefaultCamera(sourceGraph: TemplateGraph): Camera {
    const cameras = getOwnedNodes(sourceGraph, Camera)
    if (cameras.length === 0) throw new Error(`Default camera template ${DEFAULT_CAMERA_TEMPLATE_ID} contains no camera.`)
    if (cameras.length > 1) throw new Error(`Default camera template ${DEFAULT_CAMERA_TEMPLATE_ID} contains ${cameras.length} cameras, expected exactly one.`)

    const [camera] = cameras
    for (const [key, value] of Object.entries(camera.parameters)) {
        if (isTemplateNode(value))
            throw new Error(`Default camera parameter '${key}' is connected to a node instead of holding a plain value, which cannot be copied.`)
    }

    return new Camera({parameters: {...camera.parameters}})
}

// The caller provides the raw fetch (Apollo in the editor, the API SDK in the seeding scripts), so that this package
// stays free of any API client dependency.
export async function loadDefaultCamera(fetchTemplateGraph: (templateId: string) => Promise<unknown>): Promise<Camera> {
    const graphJson = await fetchTemplateGraph(DEFAULT_CAMERA_TEMPLATE_ID)
    if (!graphJson) throw new Error(`Default camera template ${DEFAULT_CAMERA_TEMPLATE_ID} has no revision with a graph.`)
    return extractDefaultCamera(deserializeTemplateGraph(graphJson as SerializedGraphNode))
}

export function insertDefaultCamera(modify: IModifyTemplateGraph, camera: Camera): void {
    modify.modifyTemplateGraph((templateGraph) => {
        templateGraph.parameters.nodes.addEntry(camera)
    })
}
